import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Typography,
  Box,
  Divider,
  IconButton,
  CardContent,
  Tooltip,
} from '@mui/material';
import Header1 from '../Header/Header1';
import Footer2 from '../Footer/Footer2';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import Appointments from '../Footer/Appointments';

const ContactUs = ({ userId, loggedIn, onLogout }) => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleLogout = () => {
    onLogout();
    navigate('/login');
  };

  return (
    <Box sx={{ backgroundColor: '#000000', color: '#e0e0e0', minHeight: '100vh' }}>
      
      <Header1 />

      {/* Main Content */}
      <Container maxWidth="md" sx={{ pt: 10, pb: 8, minHeight: '10vh' }}>
        {/* Page Title */}
        <Box textAlign="center">
          <Typography
            variant="h3"
            component="h1"
            sx={{
              fontWeight: 700,
              fontSize: { xs: '24px', sm: '32px' },
              letterSpacing: 6,
              color: '#ffffff',
              mb: 1,
            }}
          >
            Contact Us
          </Typography>
          <Typography variant="subtitle2" sx={{ color: '#aaaaaa', letterSpacing: 2 }}>
            <strong>Last updated:</strong> June 30, 2026
          </Typography>
        </Box>

        <Divider sx={{ backgroundColor: '#333', mb: 4 }} />

        {/* Contact Info */}
        <Box
          sx={{
            backgroundColor: '#000000',
            borderRadius: 2,
            boxShadow: '0 0 15px rgba(0,0,0,0.3)',
            mb: 5,
            px: 3,
            py: 4,
          }}
        >
          <CardContent>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 2,
              }}
            >
              <Typography
                variant="body1"
                sx={{ color: '#e0e0e0', letterSpacing: 1.5, textAlign: 'center' }}
              >
                Anthrasync Solutions Private Limited
              </Typography>

              <Typography
                variant="body1"
                sx={{ color: '#e0e0e0', letterSpacing: 1.5, textAlign: 'center' }}
              >
                <strong>Address:</strong> No 26, Laskar Hosur Road, Adugodi, Bangalore South,
                Bengaluru, Karnataka 560030, India
              </Typography>
            </Box>
          </CardContent>
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mb: 2 }}>
                            <IconButton
                              sx={{
                                color: '#1abc9c',
                                fontSize: '2rem',
                                marginRight: '12px',
                                '&:hover': { color: '#16a085' },
                              }}
                            >
                              {/* <EmailIcon /> */}
                            </IconButton>
                            <Typography sx={{ color: '#BDC3C7', fontSize: '1rem' }}>
                              contact@anthrasync.com
                            </Typography>
                          </Box>
                          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <IconButton
                              sx={{
                                color: '#1abc9c',
                                fontSize: '2rem',
                                marginRight: '12px',
                                '&:hover': { color: '#16a085' },
                              }}
                            >
                              {/* <PhoneIcon /> */}
                            </IconButton>
                            {/* <Typography sx={{ color: '#BDC3C7', fontSize: '1rem' }}>
                              +91 7338259131
                            </Typography> */}
                          </Box>
        </Box>

        {/* Google Calendar Appointment Scheduling (commented out) */}
        {/* <Box
          sx={{
            mb: 6,
            border: '1px solid #444',
            borderRadius: 2,
            overflow: 'hidden',
            boxShadow: '0 0 10px rgba(0,0,0,0.4)',
          }}
        >
          <iframe
            src="https://calendar.google.com/calendar/appointments/schedules/AcZssZ0G3d7qWB_ZTGJ8OGjjCR4VpM6YQ6nBEzJ4YpMtueSJ_l4ApI5sy80wqrknyolLr_ndgqOYlxO4?gv=true"
            style={{ border: 0, width: '100%', height: 600 }}
            frameBorder="0"
            title="Appointment Scheduling"
          />
        </Box> */}
      </Container>

      <Appointments />

      {/* Scroll to Top Button */}
      <Tooltip title="Scroll to Top" placement="left">
        <IconButton
          onClick={scrollToTop}
          sx={{
            position: 'fixed',
            bottom: 20,
            right: 20,
            backgroundColor: '#333',
            color: '#90caf9',
            boxShadow: '0 4px 12px rgba(0,0,0,0.5)',
            '&:hover': {
              backgroundColor: '#444',
              color: '#ffffff',
            },
          }}
        >
          <ArrowUpwardIcon />
        </IconButton>
      </Tooltip>

      {/* Footer */}
      <Footer2 />
    </Box>
  );
};

export default ContactUs;
